<template>
  <div class="home-container">
    <div class="home-content">
  <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="楼栋名称"
                prop="name"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.name"
                  placeholder="请输入楼栋名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px;display: flex;">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          type="danger"
          icon="el-icon-upload2"
          @click="generateBill"
          >批量生成账单</el-button>   
        <el-button
          size="small"
          type="primary"
          icon="el-icon-download"
          @click="download"
          >下载导入模板</el-button>     
        <el-upload
          class="avatar-uploader"
          ref="upload"
          action=""
          :http-request="handleUpload"
          :show-file-list="false"
        >
          <el-button
            size="small"
            type="primary"
            style="margin-left: 10px"
            icon="el-icon-upload2"
          >
            批量导入
          </el-button>
        </el-upload>
      </div>

      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        @selection-change="handleSelectionChange"
        v-loading="isShowloading"
        style="width: 100%"
      >
          <el-table-column
          type="selection"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column prop="id" label="id" align="center">
        </el-table-column>
        <el-table-column prop="weight" label="排序" align="center">
        </el-table-column>
        <el-table-column prop="name" label="楼栋信息" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="20%" @close="close">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="排序" prop="weight">
                 <el-input-number v-model="addData.weight"  :min="1"  label="请输入序号"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="楼栋信息" prop="name">
                <el-input
                  v-model="addData.name"
                  placeholder="请输入楼栋信息"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="close()">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 批量生成账单 -->
      <el-dialog title="批量生成账单" :visible.sync="billFlags" width="50%" @close="billClose">
        <el-form
          ref="billForm"
          :model="fromData"
          label-width="150px"
          :rules="fromDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="缴费类型" prop="billCategoryId">
                <el-select clearable filterable v-model="fromData.billCategoryId" placeholder="请选择类型" >
                  <el-option
                    v-for="(item, ind) in typeData"
                    :key="ind"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              
            </el-col>
            <el-col :span="12">
              <el-form-item label="单价（/平方米/月）" prop="unitPrice">
                <el-input-number style="width: 200px" v-model="fromData.unitPrice" :precision="2" :min="0" :max="99999999" placeholder="请输入单价"></el-input-number>
                
              </el-form-item>
            </el-col>
            
            <!-- <el-col :span="12">
              <el-form-item label="缴费模板" prop="billTemplateId" label-width="120px">
                <el-select clearable filterable v-model="fromData.billTemplateId" placeholder="请选择模板">
                  <el-option
                    v-for="(item, ind) in templateData"
                    :key="ind"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>             -->
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="缴费周期" prop="cycleStartTime">
                <el-date-picker
                  v-model="fromData.cycleStartTime"
                  type="monthrange"
                  value-format="yyyy-MM"
                  start-placeholder="开始日期"
                  unlink-panels
                  end-placeholder="结束日期"
                  placeholder="选择开始日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="12">
              <el-form-item label="开始日期" prop="time">
                  <el-date-picker
                    v-model="fromData.time"
                    type="date"
                    placeholder="选择开始日期">
                  </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="账单期数(月)" prop="month" label-width="120px">
               <el-input-number v-model="fromData.month" :min="1" :max="12" label="请输入账单缴费期数"></el-input-number>
              </el-form-item>
            </el-col>            
          </el-row>    
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder="请输入备注"
                    v-model="fromData.remark">
                  </el-input>
              </el-form-item>
            </el-col>     
            <el-col :span="12" v-if="isFixedAmount == -1">
              <el-form-item label="单位数量(度/吨)"  label-width="120px">
                <el-input-number v-model="fromData.unitCount" :min="1" label="请输入账单缴费数量"></el-input-number>
              </el-form-item>
            </el-col>    
          </el-row>                    -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="billFlags = false">取 消</el-button>
          <el-button type="primary" @click="billSubmit"
            >确 定</el-button
          >
        </span>
      </el-dialog>      
    </div>
  </div>
</template>

<script>
import unit from "./unit.vue"
import reg from "../../utils/reg"
export default {
  components:{
    unit
  },
  data() {
    return {
      searchForm: {
        name: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      fromData:{
        billCategoryId:'',
        // unitPrice:'',
        cycleStartTime:[],
        // billTemplateId:'',
        // month:'',
        // remark:'',
        // time:'',
        // unitCount:'',
      },
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag:true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "", 
        name: "", 
        weight:""
      },
      addDataRules: {
        name: [
          { required: true, message: "请输入楼栋名称", trigger: "blur" },
        ],
      },
      fromDataRules:{
        billCategoryId: [
          { required: true, message: "请选择缴费类型", trigger: "blur" },
        ],
        cycleStartTime: [
          { required: true, message: "请输入选择缴费周期", trigger: "change" },
        ],
        unitPrice: [
          { required: true, message: "请输入单价", trigger: "blur" },
        ]   
        // billTemplateId: [
        //   { required: true, message: "请选择缴费模板", trigger: "blur" },
        // ],
        // month: [
        //   { required: true, message: "请输入缴费月数", trigger: "blur" },
        // ],     
        // time: [
        //   { required: true, message: "请输入开始缴费日期", trigger: "blur" },
        // ],     

      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      multipleSelection:[],
      billFlags:false,
      typeData:[],
      templateData:[],
      isFixedAmount:''
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    handleUpload({ file }) {
      try {
        const loading = this.$loading({
          lock: true,
          text: "上传中,请稍后...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$Apis.getExportCode().then(res=>{
          if(res.code == 200){
            var formData = new FormData();
            formData.append("file", file);
            formData.append("uCode",res.data)
            formData.append(
              "villageId",
              JSON.parse(localStorage.getItem("park_data")).id
            );
            this.$Apis.importBatchHome(formData).then((res) => {
              loading.close();
              if (res.code == 200) {
                this.$message.success(res.msg);
                this.onLoad();
              } else {
                this.$message.warning(res.msg);
              }
             
            });
          }
        })
        
      } catch (error) {
        loading.close();
      }
    },
    download(){
      this.$Apis.getExportCode().then(res=>{
        if(res.code == 200){
          window.location.href = process.env.VUE_APP_UPLOAD_REAL_PATH + '/export/batchHomeTemplate?uCode=' + res.data
        }
      })
      
    },
    // getBillId(e){
    //   let id = this.typeData.filter(res=> e == res.id)
    //   if(id.length > 0){
    //     this.isFixedAmount = id[0].isFixedAmount
    //   }
    // },
    // 批量生成提交
    billSubmit(){
      this.$refs["billForm"].validate((valid)=>{
      if(valid){
        let startDate = this.fromData.cycleStartTime[0] ? this.fromData.cycleStartTime[0] + '-01' : '';
        let endDate = '';
        if (this.fromData.cycleStartTime[1]) {
          // 获取该月最后一天
          const [year, month] = this.fromData.cycleStartTime[1].split('-');
          const lastDay = new Date(year, month, 0).getDate();
          endDate = `${this.fromData.cycleStartTime[1]}-${lastDay}`;
        }
        let data = {
          // time:reg.filterTime(this.fromData.time),
          // billCategoryId:this.fromData.billCategoryId,
          // billTemplateId:this.fromData.billTemplateId,
          // month:this.fromData.month,
          ridgepoleIds:this.multipleSelection.join(','),
          // unitCount:this.fromData.unitCount || ''
          billCategoryId: this.fromData.billCategoryId,
          cycleStartTime: startDate,
          cycleEndTime: endDate,
          unitPrice: this.fromData.unitPrice,
        }
        this.$Apis.billCreateBillRidgepole(data).then(res=>{
          if(res.code == 200){
            this.billFlags = false
            this.$refs.multipleTable.clearSelection();
            this.$message.success(res.msg)
          }else{
            this.$message.warning(res.msg)
          }
        })
      }
      })
    },
    // 
    generateBill(){
      if(this.multipleSelection.length > 0){
        for (let item in this.fromData) {
            this.fromData[item] = "";
        } 
        this.fromData.billCategoryId = 1
        this.billFlags = true
      }else{
        this.$message.warning("请选择后，在操作！");
      }
    },
    // 全选
    handleSelectionChange(e){
      var arrId = [];
      if (e.length > 0) {
        e.forEach((res) => {
          arrId.push(res.id);
        });
      }
      this.multipleSelection = arrId;
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },    
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    close(){
      this.$refs.form.resetFields();
      this.isAddModal = false;
      
    },
    billClose(){
      this.$refs.billForm.resetFields()
      this.billFlags = false
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row))
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.houseDel({ id }).then((res) => {
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("删除成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id:this.addData.id || "",
            weight:this.addData.weight,
            name: this.addData.name,
          };
          this.$Apis.houseAddUp(data).then((res) => {
            this.btnLoading = false;
            
            if (res.code == 200) {
              this.onLoad();
              this.close()
              this.isAddModal = false;
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad()
    },
    onLoad(ind) {
      this.isShowloading = true;
      if(ind == 1){
        this.currentPage = 1
      }
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        name:this.searchForm.name
      };
       this.$Apis.billCategoryAllList().then((res) => {
          if(res.code == 200){
              this.typeData = res.data
          }
       })  
      //  this.$Apis.billTemplateAllList().then((res) => {
      //     if(res.code == 200){
      //         this.templateData = res.data
      //     }
      //  })              
      this.$Apis.houseList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item,ind) => {
            item.ind = ind + 1
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>